<script lang="ts">
  import { get,  writable } from "svelte/store"; 
import type { IActivityDTO } from "../../services/DTO";
import ActivityDetailPage from "../Activity/ActivityDetailPage.svelte";
import ActivityDetailPartGeneral from "../Activity/ActivityDetailPartGeneral.svelte";
import ActivityListPageInner from "../Activity/ActivityListPageInner.svelte";

  
import {
    loadActivities
  } from "./lead.store";

  const editing = writable<boolean>(false);
  export let oid: number;
   
  let activityId : number = null;

  function onCreate(){
    activityId = 0;
  }

  function onClose(){
    activityId = null;
  }

  function onEdit(event){
    activityId = event.activity.oid;
  }

  function onSave(event)
  {
    loadActivities(oid);
  }

</script>
{#if activityId == null}
    <ActivityListPageInner entityId={oid} entityTpe={'Lead'} 
        on:create={() => onCreate()} on:edit={(ev) => onEdit(ev.detail)} />
  {:else}
    <ActivityDetailPartGeneral oid={activityId} entityId={oid} type={'Lead'} on:close={() => onClose()} on:save={(ev) => onSave(ev.detail)} />
{/if} 